module.exports = __webpack_public_path__ + "img/alexhead_06.dab368e5.svg";